import React from "react";
import { cva, VariantProps } from "class-variance-authority";
import clsx from "clsx";

const featuredIconVariants = cva("inline-flex items-center justify-center rounded-full shrink-0", {
  variants: {
    size: {
      xs: "size-6",
      sm: "size-8",
      md: "size-10",
      lg: "size-12",
      xl: "size-14",
    },
    color: {
      white: "bg-primary text-primary",
      natural: "bg-secondary text-primary",
      primary: "bg-brand-primary-subtle text-brand-primary",
      secondary: "bg-brand-secondary-subtle text-brand-secondary",
      success: "bg-success-primary text-success",
      warning: "bg-warning-primary text-warning",
      error: "bg-error-primary text-error",
      numeric: "bg-error-solid text-primary-brand",
    },
  },
  defaultVariants: {
    size: "md",
    color: "primary",
  },
});

const iconSizeVariants = cva("", {
  variants: {
    size: {
      xs: "size-3",
      sm: "size-4",
      md: "size-5",
      lg: "size-6",
      xl: "size-7",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export type FeaturedIconProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof featuredIconVariants> & {
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | React.ReactNode;
  };

const FeaturedIcon = ({ icon, color, size, className, ...props }: FeaturedIconProps) => {
  const iconProps = { className: clsx(iconSizeVariants({ size })) };

  return (
    <div className={clsx(featuredIconVariants({ size, color }), className)} {...props}>
      {typeof icon === "function" ? React.createElement(icon, iconProps) : icon}
    </div>
  );
};

export default FeaturedIcon;
